var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoginCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 44,
    viewBox: "0 0 24 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3107 21.5154C22.2992 19.2143 24.1762 15.5384 23.986 11.4286C23.7081 5.37845 18.8329 0.415488 12.7925 0.0254716C5.80637 -0.423048 0 5.11031 0 11.999C0 15.8748 1.83795 19.3167 4.68508 21.5105C5.07022 21.8079 5.59186 21.842 6.01113 21.6031C7.77596 20.5842 9.81867 20.0041 11.9979 20.0041C14.1771 20.0041 16.2247 20.5891 17.9895 21.6031C18.4088 21.842 18.9304 21.8079 19.3107 21.5154Z",
    fill: "#F7DE2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3149 22.4901C18.9298 22.1928 18.4081 22.1586 17.9889 22.3975C16.224 23.4164 14.1813 23.9966 12.0021 23.9966C9.82289 23.9966 7.7753 23.4116 6.01048 22.3975C5.59121 22.1586 5.06956 22.1928 4.6893 22.4853C1.69592 24.7864 -0.17616 28.4672 0.0139736 32.5721C0.296736 38.6222 5.16707 43.59 11.2075 43.9752C18.1936 44.4237 24 38.8903 24 32.0017C24 28.1259 22.162 24.684 19.3149 22.4901Z",
    fill: "#F7DE2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginCode);
export default __webpack_public_path__ + "static/media/icon_login_code.c1866a657c92dcbe21d3ab8c4c9157cf.svg";
export { ForwardRef as ReactComponent };